import React, { useEffect } from "react";
import BillieBanner from "../assets/BillieBanner.png";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";


const Banner = () => {

  useEffect(() => {
    AOS.init({
      once: true,
      duration: 800,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <section className="min-h-screen flex flex-col justify-center bg-background text-text pt-20 px-6 overflow-hidden relative">


      <div className="max-w-6xl mx-auto px-6 w-full z-10 grid md:grid-cols-12 gap-8 md:gap-16 items-center">
        <div className="md:col-span-6 relative md:pr-12 md:border-r border-border  h-full flex flex-col justify-center">
          <div
            data-aos="fade-right"
            data-aos-delay="400"
            className="relative group rounded-[2.5rem] overflow-hidden border border-border bg-secondary/5 p-4"
          >
            <div className="relative aspect-[4.5/5] rounded-[2rem] overflow-hidden">
              <img
                src={BillieBanner}
                alt="Billie Zhang"
                className="w-full h-full object-cover group-hover:grayscale transition-all duration-700 scale-105 group-hover:scale-100"
              />
            </div>
          </div>
        </div>

        <div className="md:col-span-6 flex flex-col justify-center pr-0 md:pr-12">
          <div data-aos="fade-up" data-aos-delay="0" className="flex items-center gap-4 mb-8">
            {/* TODO if you add text, change w-32 to w-12 */}
            <div className="h-px w-32 bg-secondary"></div>
            <span className="text-xs uppercase tracking-[0.4em] text-secondary font-bold">
              {/* TODO ADD SOMETHING?  */}
            </span>
          </div>

          <h1
            data-aos="fade-up"
            data-aos-delay="100"
            className="text-6xl md:text-8xl lg:text-9xl font-bold tracking-tighter leading-[0.9] mb-8"
          >
            Billie <br />
            <span className="text-secondary opacity-40">Zhang.</span>
          </h1>

          <div data-aos="fade-up" data-aos-delay="200" className="max-w-2xl">
            <p className="text-2xl md:text-3xl font-light leading-relaxed text-text mb-8">
              product manager & <span className="italic text-secondary">software developer.</span>
            </p>
          </div>

          <div data-aos="fade-up" data-aos-delay="300" className="flex flex-wrap gap-4 md:gap-6 items-center">
            <a
              href="#experience"
              className="group flex items-center gap-3 px-8 py-4 bg-text text-background rounded-full font-medium hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              view work
              <ArrowDown size={18} className="group-hover:translate-y-1 transition-transform duration-300" />
            </a>
            <a
              href="mailto:billie.zhang@uwaterloo.ca"
              className="group flex items-center gap-2 px-6 py-4 text-text font-medium hover:text-secondary transition-colors"
            >
              get in touch
              <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Banner;